import React, { useContext, FormEvent, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { captcha as ACaptcha } from "a-captcha";

import Input from "../../../components/Form/Input";
import Password from "../../../components/Form/Password";
import Button from "../../../components/Form/Button";
import AuthContext from "../../../contexts/AuthContext";

import { useLocation } from "react-router-dom";
import { AuthResponse } from "../../../services/api/Login";

const FormLogin: React.FC = () => {
  const isDev = process.env.REACT_APP_ALLOW_LOCAL_LOGIN === 'true' ||
                (process.env.REACT_APP_ALLOW_LOCAL_LOGIN !== 'false' && window.location.hostname === 'localhost');
  const { Login, signInSaml } = useContext(AuthContext);
  const query = useQuery();
  const history = useHistory();
  const [message, setMessage] = useState("");
  const [captcha, setCaptcha] = useState<{
    text: string;
    buffer: Buffer;
  } | null>(null);

  async function CreateCaptcha() {
    const { text, buffer } = await ACaptcha({ length: 6, sw: 2 });
    setCaptcha({ text: text, buffer: buffer });
  }

  function useQuery(): URLSearchParams {
    return new URLSearchParams(useLocation().search);
  }

  async function handleFormSubmit(event: FormEvent) {
    event.preventDefault();

    if (!isDev) {
      return;
    }

    const formData: FormData = new FormData(event.target as HTMLFormElement);
    let data: any = {};
    formData.forEach((value: FormDataEntryValue, key: string) => {
      data[key] = value;
    });

    if (window.location.hostname === 'localhost' || captcha!.text === data.captcha) {
      const response: AuthResponse = await Login(data);
      if (response.status === 200) {
        const redirect = query.get("redirect_to");
        history.push(!!redirect ? redirect : "/");
      } else {
        setMessage(response.message);
      }
    } else {
      setMessage("Please, check the captcha");
    }
  }

  useEffect(() => {
    if (isDev) {
    CreateCaptcha();
    }
  }, [isDev]);

  if (!isDev) {
    return (
      <form className="container form login" onSubmit={(e) => e.preventDefault()}>
        <p>
          <Button
            onClick={(event: any) => {
              event.preventDefault();
              signInSaml();
            }}
            className="button button--big button--login-rb"
            title="Login with Red Bull Account"
          />
        </p>
      </form>
    );
  }

  return (
    <React.Fragment>
      {captcha === null ? null : (
        <React.Fragment>
          <p className="errorMsg">{message}</p>
          <form className="container form login" onSubmit={handleFormSubmit}>
              <Input
                name="email"
                placeholder="Please enter your e-mail"
                autocomplete="email"
                required
              />

              <Password
                name="password"
                placeholder="Please enter your password"
                autocomplete="password"
                required
              />

              <div className="form-group form-group--captcha">
                <input
                  className="form-input form__input form__input--captcha"
                  id="captcha"
                  name="captcha"
                  placeholder="Please enter the captcha"
                  required
                  autoComplete="off"
                />

                <img
                  className="form__img-captcha"
                  src={`data:image/png;base64,${Buffer.from(
                    captcha!.buffer
                  ).toString("base64")}`}
                />
              </div>

              <Button
                title="Login"
                className="button button--big button--darkblue"
              />
          </form>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default FormLogin;
